export const DESKTOP_STUDIO_BASE_PATH = '/desktop'

export type DesktopHref =
  | string
  | {
      pathname: string
      query?: Record<string, string | undefined>
      hash?: string
    }

export function desktopHrefToString(href: DesktopHref): string {
  if (typeof href === 'string') {
    return href
  }

  const params = new URLSearchParams()
  if (href.query) {
    for (const [key, value] of Object.entries(href.query)) {
      if (value !== undefined && value !== '') {
        params.set(key, value)
      }
    }
  }
  const search = params.toString()
  const hash = href.hash ? (href.hash.startsWith('#') ? href.hash : `#${href.hash}`) : ''

  return `${href.pathname}${search ? `?${search}` : ''}${hash}`
}

export function resolveDesktopHref(basePath: string, href: DesktopHref): string {
  const serialized = desktopHrefToString(href)
  const hashIndex = serialized.indexOf('#')
  const pathWithSearch = hashIndex === -1 ? serialized : serialized.slice(0, hashIndex)
  const hash = hashIndex === -1 ? '' : serialized.slice(hashIndex)
  const queryIndex = pathWithSearch.indexOf('?')
  const path = queryIndex === -1 ? pathWithSearch : pathWithSearch.slice(0, queryIndex)
  const search = queryIndex === -1 ? '' : pathWithSearch.slice(queryIndex)

  if (!basePath) {
    return `${path || '/'}${search}${hash}`
  }

  if (!path || path === '/') {
    return `${basePath}${search}${hash}`
  }

  return `${basePath}${path}${search}${hash}`
}

export function resolveInstallerUrl(installerOrigin: string, href: string): string {
  if (!installerOrigin || href.startsWith('http://') || href.startsWith('https://')) {
    return href
  }

  return `${installerOrigin}${href}`
}
